import { css } from '@emotion/core';
import styled from '@emotion/styled';

const BadgeLarge = styled.div`
  background: ${({ theme }) => theme.colors.bgPrimary};
  display: flex;
  flex-wrap: wrap;
  border: ${props => props.theme.borders.grey3100};
  padding: 8px 16px;
  margin-right: 6px;
  margin-top: 6px;
  border-radius: 4px;

  svg {
    position: relative;
    top: -6px;
  }
`;

const BadgeLargeDesktop = styled.div`
  display: flex;
  box-align: center;
  align-items: center;
  height: 32px;
  padding: 6px 16px;
  margin: 16px 4px 0px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.bgPrimary};
  border: 1px solid ${({ theme }) => theme.colors.grey5};

  svg {
    position: relative;
    top: -3px;
  }
`;

const BadgeSmall = styled.div`
  background: ${({ theme }) => theme.colors.bgPrimary};
  border: 1px solid ${({ theme }) => theme.colors.grey3};
  border-radius: 16px;
`;

const iconStyle = theme => css`
  color: ${theme.colors.primary};
`;

const Label = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.sizes.m};
  color: ${({ theme }) => theme.colors.primary};
  margin-left: 4px;
`;

export default { BadgeLarge, BadgeLargeDesktop, BadgeSmall, Label, iconStyle };
